import { Principal, Teacher, ConversationTeacher, PrivateTeacher, Coordinator } from 'assets'
import { roleNames } from 'keys/roles'

const useRoleList = () => {

    const roleList = {
        [roleNames.principal]: {
            icon: Principal,
        },
        [roleNames.teacher]: {
            icon: Teacher,
        },
        [roleNames.grade_coordinator]: {
            icon: Coordinator,
        },
        [roleNames.homeroom_teacher]: {
            icon: Teacher,
        },
        [roleNames.instructional_coordinator]: {
            icon: Coordinator,
        },
        [roleNames.reading_intervention_teacher]: {
            icon: Teacher
        },
        [roleNames.homeroom_teacher]: {
            icon: Teacher
        },
        [roleNames.private_teacher]: {
            icon: PrivateTeacher
        },
        [roleNames.municipal_language_instruction_coordinator]: {
            icon: Coordinator
        },
        ["default"]: {
            icon: Coordinator
        }
    }

    return roleList
}

export default useRoleList